/* Gratis kittenpakket auto add/remove (added 2026-08-06).
   Shopify's native Buy X Get Y discount only DISCOUNTS an item already in the
   cart - it cannot add it. This script does the adding/removing; the
   Buy X Get Y automatic discount (Shopify Admin > Discounts) still owns the
   pricing (makes it EUR0,00 at checkout once the EUR50 condition is met -
   threshold raised from EUR35 2026-08-14, see cogs-mapping.md; the discount
   object's own minimum-purchase condition needs updating separately in
   Shopify Admin, this app lacks the read_discounts/write_discounts scope to
   do it via API - since EUR50 > the old EUR35 floor, this is not a
   functional break, just stale config worth aligning).
   Only affects the storefront cart - Shopify's checkout page itself is a
   separate hosted domain this script cannot run on, so any last-second
   quantity edit made ON the checkout page itself is not covered by this. */
(function () {
  var GIFT_VARIANT_ID = 49452561826127;
  var THRESHOLD_CENTS = 5000;
  var syncing = false;

  function qualifyingTotal(cart) {
    var sum = 0;
    cart.items.forEach(function (item) {
      if (item.variant_id !== GIFT_VARIANT_ID) sum += item.final_line_price;
    });
    return sum;
  }

  function findGift(cart) {
    return cart.items.find(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }

  function syncGift() {
    if (syncing) return;
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qualifies = qualifyingTotal(cart) >= THRESHOLD_CENTS;
        var gift = findGift(cart);

        if (qualifies && !gift) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
          }).then(function () { return true; });
        }
        if (!qualifies && gift) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 0 }),
          }).then(function () { return true; });
        }
        return false;
      })
      .then(function (changed) {
        syncing = false;
        if (changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kittenpakket-auto-gift' });
        }
      })
      .catch(function () {
        syncing = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncGift();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'kittenpakket-auto-gift') return;
        syncGift();
      });
    }
  });
})();
